const ACCESS_TOKEN_KEY = 'accessToken'
const REFRESH_TOKEN_KEY = 'refreshToken'

const setAccessToken = token => localStorage.setItem(ACCESS_TOKEN_KEY, token)
const getAccessToken = () => localStorage.getItem(ACCESS_TOKEN_KEY)
const removeAccessToken = () => localStorage.removeItem(ACCESS_TOKEN_KEY)

const setRefreshToken = token => localStorage.setItem(REFRESH_TOKEN_KEY, token)
const getRefreshToken = () => localStorage.getItem(REFRESH_TOKEN_KEY)
const removeRefreshToken = () => localStorage.removeItem(REFRESH_TOKEN_KEY)

const tokenService = {
  setAccessToken,
  getAccessToken,
  removeAccessToken,
  setRefreshToken,
  getRefreshToken,
  removeRefreshToken
}

export default tokenService



//////////////////
// WEBPACK FOOTER
// ./plugins/tokenService.js
// module id = null
// module chunks = 